import { useMemo } from "react";
import useDevice from "src/hooks/useDevice";
import { paddingLarge, paddingMedium } from "src/styles/spacing";

const useEditCoverGalleryPadding = () => {
	const { device } = useDevice();
	return useMemo(() => {
		return {
			paddingHorizontal: device === "desktop" ? paddingLarge : paddingMedium,
		};
	}, [device]);
};
export default useEditCoverGalleryPadding;
